module.exports = __webpack_public_path__ + "img/hs-bg.4d0f61bd.jpg";